(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('ProfileDetailController', ProfileDetailController);

    ProfileDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'Profile', 'User', 'Position', 'Education'];

    function ProfileDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, Profile, User, Position, Education) {
        var vm = this;

        vm.profile = entity;
        loadPicture(vm.profile);
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('quilinkApp:profileUpdate', function(event, result) {
            vm.profile = result;
        });
        $scope.$on('$destroy', unsubscribe);
       
    }

    function loadPicture(profile){
        if (profile.pictureContentType){
            Picture.getProfilePicture(profile.id).then(function (response) {
                profile.picture=response;
            }, function (response) {
                console.log(response);
            });
        }
    }

})();
